import { PurchaseGetDraftResponse } from '@common'
import { ListenerEffectAPI, PayloadAction } from '@reduxjs/toolkit'

import { api } from '@/api'
import { AppDispatch, RootState } from '@/store'
import logger from '@/utils/logger'

import { syncWithDraft } from '../features/checkout/checkoutSlice'

const onGetDraft = async (
  action: PayloadAction<PurchaseGetDraftResponse>,
  listenerAPI: ListenerEffectAPI<RootState, AppDispatch>,
) => {
  if (!action.payload) {
    return
  }
  const localRevision = listenerAPI.getState().checkout.draft?.revision
  const remoteRevision = action.payload.revision
  if (localRevision === remoteRevision) {
    return
  }
  const market = listenerAPI.getState().config.market
  if (market?.countryCode !== action.payload.country) {
    logger.debug('market country code does not match draft country code')
    return
  }
  const lang = listenerAPI.getState().config.locale
  if (lang !== action.payload.language) {
    logger.debug('page locale does not match draft language')
    return
  }
  await listenerAPI.dispatch(syncWithDraft({ draft: action.payload, market }))
}

const getDraftListenerMiddleware = {
  effect: onGetDraft,
  matcher: api.endpoints.getDraft.matchFulfilled,
} as const

export default getDraftListenerMiddleware
